import React, { useState, useCallback } from 'react';

import {
  Channel,
  ChannelWrapper,
  ContentWrapper,
  Description,
  Icon,
  Item,
  StyledRaw,
  Title,
  Wrapper
} from './styles/component';
import Picture from 'shared/components/presentational/Picture';

const Accordion = ({
  channels,
  descriptions,
  hasDescriptionsIcon,
  displayChevron,
  index,
  isMoreChannels,
  moreChannelsIcon,
  title
}: {
  channels: { label: string | null; href: string }[];
  descriptions: { icon: string; content: string }[];
  hasDescriptionsIcon: boolean;
  displayChevron: boolean;
  index: number;
  isMoreChannels: boolean;
  moreChannelsIcon: { label: string | null; href: string };
  title: string;
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleToggle = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const renderChannels = useCallback((channel, index) => {
    return (
      <Channel
        key={`${channel?.label}-${index}`}
        alt={channel?.label}
        url={channel?.href}
      />
    );
  }, []);

  const displayChannelsList = isMoreChannels
    ? [...channels, moreChannelsIcon]
    : channels;

  return (
    <Wrapper>
      {displayChevron ? (
        <Item
          key={index}
          type="button"
          onClick={handleToggle}
          aria-expanded={isOpen}
          aria-controls={`group-${index}`}
          id={`item-${index}`}
        >
          {title}
          {displayChannelsList.length > 0 && displayChevron && (
            <Icon
              name={`${isOpen ? 'ArrowTop' : 'ArrowBottom'}`}
              width="12px"
              height="12px"
            />
          )}
        </Item>
      ) : (
        <Title>{title}</Title>
      )}
      <ContentWrapper
        role="region"
        id={`group-${index}`}
        aria-labelledby={`item-${index}`}
        aria-hidden={!isOpen}
      >
        {descriptions?.map((description, index) => (
          <Description key={`${description.icon}-${index}`}>
            {description.icon && (
              <div>
                <Picture url={description.icon} alt="" />
              </div>
            )}
            <StyledRaw
              hasMarginLeft={hasDescriptionsIcon && !description.icon}
              html={description.content}
            />
          </Description>
        ))}
        <ChannelWrapper>
          {displayChannelsList.map(renderChannels)}
        </ChannelWrapper>
      </ContentWrapper>
    </Wrapper>
  );
};

export default Accordion;
